import React from 'react'

const AddLocation = () => {
  return (
    <div>
      <h1>AddLocation</h1>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Text</h4>
      <h4>Ultima línea</h4>
    </div>
  )
}

export default AddLocation